import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import Button from '../../../../components/Button';
import { Col } from '../../../../foundations/Grid';

export const ColNavUtilityContainer = styled(Col)`
  ${({ theme }) => css`
    display: flex;
    width: 100%;
    padding: 0;
    margin-top: ${rem(360)};

    ${theme.largeUp() && css`
      position: relative;
      width: auto;
      padding-right: 0;
      margin-top: ${rem(-40)};
      float: right;
    `}
    ${theme.large1200Up() && css`
      margin-top: ${rem(-115)};
    `}
    ${theme.xlargeUp() && css`
      padding: 0 ${rem(16)};
    `}

  `
}
`;

export const NavStyled = styled.nav`
  ${({ theme }) => css`
      z-index: ${theme.zIndex.globalNavMain};
      width: 100%;
    `}
`;

export const LiNavLinkContainerStyled = styled.li`
  ${({ theme, mobileButton }) => {
    const largeUp = theme.largeUp();
    return css`
      display: flex;
      height: ${rem(60)};
      align-items: center;
      border-bottom: 1px solid ${theme.colors.neutral.grayDark20};
      background-color: ${theme.colors.background.darkTheme.darkDefault};
      &:nth-child(-n + 2) {
        &::after {
          ${largeUp && css`
            position: relative;
            color: ${theme.colors.neutral.white};
            content: '|';
            font-weight: 100;
          `}
        }
      }
      ${largeUp && css`
        display: inline-flex;
        height: ${rem(40)};
        padding: 0;
        border-bottom: none;
      `}
      ${mobileButton && theme.largeDown() && css`
        border: none;
        margin: ${rem(16)} 0;
        background: none;
      `}
    `;
  }
}
`;

// TODO: not sure why this is a span, investigate
export const ANAvLinkStyled = styled.span`
  ${({ theme }) => css`
      color: ${theme.colors.neutral.white};
      text-transform: uppercase;
      text-decoration: none;
      ${theme.largeDown() && css`
        display: flex;
        width: 100%;
        height: 100%;
        align-items: center;
        padding: 0 ${rem(16)};
      `}
      ${theme.largeUp() && css`
        align-self: center;
        padding: ${rem(10)} ${rem(15)} ${rem(8)};
      `}

      &:hover {
        color: ${theme.colors.neutral.white};
        text-decoration: underline;
      }
    `
}
`;

export const UlStyled = styled.ul`
  ${({ theme }) => css`
    display: block;
    ${theme.largeUp() && css`
      display: flex;
      justify-content: flex-end;
    `}`
}
`;

export const ButtonSearchStyled = styled(Button)`
  ${({ theme }) => css`
    ${theme.largeDown() && css`
        display: none;
      `}

      display: flex;
      width: ${rem(75)};
      min-width: ${rem(75)};
      align-items: center;
      padding: 0;
      border: none;
      background-color: ${theme.colors.neutral.white};
      border-radius: 0;
      color: ${theme.colors.background.darkTheme.default};
      text-indent: ${rem(-9999)};
      ${theme.largeUp() && css`
        height: ${rem(75)};
        @media all and (-ms-high-contrast: none) {
          position: absolute;
          top: 0;
          display: flex;
          align-items: center;
        }
      `}
      .nmx-icon-search {
        position: absolute;
        right: 0;
        width: 100%;
        height: ${rem(20)};
        .icon-fill {
          fill: ${theme.colors.blue.blue};
        }
        @media all and (-ms-high-contrast: none) {
          left: 0;
        }
      }
      &:hover {
        box-shadow: ${theme.effects.shadows.dp2};
        .nmx-icon-search {
          .icon-fill {
            fill: ${theme.colors.gold.goldDark1};
          }
        }
      }
      `
}
`;
